import template from './template.html';
import Draggable from "gsap/Draggable";
import TweenLite from 'gsap/TweenLite';

export default {
    name: 'range',
    template: template,
    props: [
        'title_prop',
        'max_prop',
        'value',
        'readonly',
    ],
    data() {
        return {
            dragInst: null,
            min: this.value,
            max: this.max_prop || 28,
            title: this.title_prop || 'Number of pages',
        }
    },
    methods: {
        initSlider() {
            const vm = this
            this.dragInst = Draggable.create(vm.$refs.handle, {
                type: 'x',
                bounds: vm.$refs.track,
                onDrag() {
                    vm.$emit("input", vm.validate((this.x * vm.max) / vm.$refs.track.offsetWidth + vm.min))
                }
            })
        },
        validate(value) {
            return Math.max(Math.min(parseInt(value || this.min), this.max), this.min)
        },
        sliderInputChange() {
            const x = this.handlePixelsShift > this.maxPixelDuration ? this.maxPixelDuration : this.handlePixelsShift
            TweenLite.set(this.dragInst[0].target, {
                x: x,
                onUpdate: this.dragInst[0].update
            });
        },
    },
    computed: {
        maxPixelDuration() {
            return ((Number(this.max) - this.min) * this.$refs.track.offsetWidth) / this.max
        },
        handlePixelsShift() {
            return ((Number(this.value) - this.min) * this.$refs.track.offsetWidth) / this.max
        }
    },
    watch: {
        value: 'sliderInputChange'
    },
    mounted() {
        this.initSlider()
    }
};